var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrwPrice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94951 15.125C8.76946 15.125 9.43417 14.4603 9.43417 13.6403C9.43417 12.8203 8.76946 12.1556 7.94951 12.1556C7.12955 12.1556 6.46484 12.8203 6.46484 13.6403C6.46484 14.4603 7.12955 15.125 7.94951 15.125Z",
    fill: "#35435E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9319 15.125C13.7519 15.125 14.4166 14.4603 14.4166 13.6403C14.4166 12.8203 13.7519 12.1556 12.9319 12.1556C12.112 12.1556 11.4473 12.8203 11.4473 13.6403C11.4473 14.4603 12.112 15.125 12.9319 15.125Z",
    fill: "#35435E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.988049 1.26886H3.05182L5.44105 9.63284L5.25366 10.0076C4.76023 10.9934 5.47652 12.1563 6.58173 12.1563H14.9108C15.1843 12.1563 15.4057 11.935 15.4057 11.6614C15.4057 11.3879 15.1843 11.1666 14.9108 11.1666H6.58173C6.21423 11.1666 5.97405 10.7796 6.13904 10.4503L6.27583 10.1768H14.9108C15.1317 10.1768 15.3259 10.0304 15.3869 9.81769L17.3664 2.88931C17.4089 2.73998 17.379 2.57951 17.2857 2.45532C17.1919 2.3316 17.0455 2.25862 16.8904 2.25862H4.36392L3.90094 0.638141C3.84004 0.425506 3.64578 0.279053 3.42489 0.279053H0.988049C0.71451 0.279053 0.493164 0.500398 0.493164 0.773938C0.493164 1.04748 0.71451 1.26886 0.988049 1.26886Z",
    fill: "#35435E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrwPrice);
export default __webpack_public_path__ + "static/media/drw_price.43c104ce11d1da3fd6f63bd93eba5efb.svg";
export { ForwardRef as ReactComponent };